import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type InviteUsersMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.InviteUsersInput;
}>;

export type InviteUsersMutationResult = { __typename?: 'Mutation' } & {
  inviteUsers?: GraphQLTypes.Maybe<
    { __typename?: 'InviteUsersPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const InviteUsersDocument = gql`
  mutation inviteUsers($input: InviteUsersInput!) {
    inviteUsers(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
